import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';

import { type BoardTaskStatus } from '../../../../common/types/task';

export const selectTasksByStatus = (status: BoardTaskStatus) =>
  createSelector(
    (state: RootState) => state.tasksBoard.tasks.idsByStatus[status],
    (state: RootState) => state.tasksBoard.tasks.byId,
    (ids, byId) => ids.map((id) => byId[id])
  );
